import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import {
  Box,
  Flex,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import {
  chatGuidelinesDocUrl,
  coachLinkTreeUrl,
  nurseLinkTreeUrl,
  routes,
} from "~/constants";
import { trackHeader as track } from "~/events";
import { useCurrentUser } from "~/hooks/useCurrentUser";
import { useSubscriptionPlan } from "~/hooks/useSubscriptionPlan";
import {
  ArrowNarrowRight,
  HeartCircle,
  Logo,
  MedicalCross,
  Users01,
} from "~/icons";
import { DesktopMenuItem } from "./DesktopMenuItem";

const { VITE_GENERIC_SMS_PHONE_NUMBER } = import.meta.env;
const conceivePhoneLink = `sms:${VITE_GENERIC_SMS_PHONE_NUMBER}`;

export const MyCareTeamMenu: FC = () => {
  const { t } = useTranslation();
  const user = useCurrentUser();
  const { plan } = useSubscriptionPlan();

  if (!user) return null;

  // const crewLink = user.cohort.cohortWhatsAppLink;
  const crewLink =
    "https://drive.google.com/file/d/1pKGg46R7J6irU9ZJPR6E4JqS9dFI-fE9/view?usp=sharing";

  return (
    <Menu>
      <MenuButton
        className="header-my-care-team-menu-button"
        color="fg-accent"
        bgColor="white"
        boxShadow="none"
        _active={{ bgColor: "white" }}
        _expanded={{ bgColor: "white" }}
        _focus={{ bgColor: "white" }}
        _hover={{ bgColor: "white" }}
      >
        <Trans i18nKey="navigation.myCareTeam" />
      </MenuButton>
      <MenuList w="16.5rem">
        <Flex color="th.gray3" justify="center" py={1} w="full">
          <Box>{t("navigation.myCareTeam")}</Box>
        </Flex>
        <MenuDivider borderColor="th.gray1" />
        <Flex direction="column" gap={2} w="full">
          <DesktopMenuItem
            label={t("navigation.message.conceive")}
            onClick={track.messageConceive}
            href={conceivePhoneLink}
          >
            <Logo />
            <Box>{t("navigation.message.sms")}</Box>
          </DesktopMenuItem>
          {plan == "premium" && !!crewLink && (
            <DesktopMenuItem
              label={t("navigation.message.crew")}
              onClick={track.messageCrew}
              href={crewLink}
              openInNewTab
            >
              <Users01 />
              <Flex align="center" gap={1}>
                {t("navigation.message.whatsApp")}
                <ArrowNarrowRight h={4} w={4} />
              </Flex>
            </DesktopMenuItem>
          )}
          {plan == "premium" && (
            <>
              <DesktopMenuItem
                label={t("navigation.speakWithANurse.premium.heading")}
                onClick={track.speakWithANurse}
                href={nurseLinkTreeUrl}
              >
                <MedicalCross />
                <Box>{t(`navigation.speakWithANurse.premium.link`)}</Box>
              </DesktopMenuItem>
              <DesktopMenuItem
                label={t("navigation.speakWithACoach.premium.heading")}
                onClick={track.speakWithACoach}
                href={coachLinkTreeUrl}
              >
                <HeartCircle height={4} strokeWidth="1" width={4} />
                <Box>{t(`navigation.speakWithACoach.premium.link`)}</Box>
              </DesktopMenuItem>
            </>
          )}
          {plan == "plus" && (
            <DesktopMenuItem
              label={t("navigation.speakWithANurse.plus.heading")}
              onClick={track.onDemandCoaching}
              href={routes.onDemandCoaching}
            >
              <MedicalCross />
              <Box>{t(`navigation.speakWithANurse.plus.link`)}</Box>
            </DesktopMenuItem>
          )}
        </Flex>
        <Flex justify="center" w="full">
          <MenuDivider borderColor="th.gray1" w="80%" />
        </Flex>
        <MenuItem as="a" href={chatGuidelinesDocUrl} target="_blank">
          <Flex justify="center" w="full">
            <Box>{t("navigation.chatGuidelinesDoc")}</Box>
          </Flex>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
